import React, {Fragment, useContext, useState, useEffect} from 'react';
import ErrorContext from '../contexts/ErrorContext'
import TimeDisplay from './TimeDisplay'
import moment from 'moment'

const Event = ({event,assignEvents,users,assignee,transition,onClick}) => {

    const error = useContext(ErrorContext)
    const [inTransit,setInTransit] = useState(transition)
    const lastWaypoint = event.waypoints.slice(-1)[0]
    const eventDate = moment(event.date)
    const assigneeList = event.assigneeIds.map( id => {
            const user = users.find( u => parseInt(u.id) === parseInt(id) ) || {name: "Unknown"}
            return <span className="badge badge-success mr-md-2" key={`assignee-${id}`}>&nbsp;{user.name}&nbsp;</span>
        })
    const checked = assignee.id && event.assigneeIds.includes(assignee.id.toString()) ? true : false
    const eventHasError = transition && error && error.code==="rest_cannot_edit"
    const errorMessage = eventHasError ? <div style={{width: "100%", backgroundColor: "darkred", color: "white"}}>{error.message}</div> : <Fragment/>

    useEffect( () => {
        setInTransit(transition)
    },[transition])

    return(
        <Fragment>
            {errorMessage}
            <div className="log-table" onClick={onClick}>
                <div className="log-cell text-muted"> {eventDate.format("HH:mm")}<sup style={{fontSize: "60%"}}>{eventDate.format("ss")}</sup> <i className="fas fa-long-arrow-alt-right"></i> {lastWaypoint.date ? moment(lastWaypoint.date).format("HH:mm") : ""}<sup style={{fontSize: "60%"}}>{moment(lastWaypoint.date).format("ss")}</sup> </div>
                <div className="log-cell"><TimeDisplay decimalHours={!isNaN(parseFloat(event.totalHours)) ? parseFloat(event.totalHours) : 0}/></div>
                <div className="log-cell">{assigneeList}</div>
                <div className="log-cell log-claim">
                    {assignee.isAdmin || assignee.isActiveMember ?
                    <div className="checkbox-border">
                        <input type="checkbox"
                            className={inTransit===true  ? (eventHasError ? "in-transition-error" : "in-transition") : "no-transition"} 
                            onChange={async (a) => { assignEvents([event],a.target.checked)}}
                            onClick={ a => {a.stopPropagation(); setInTransit(true);}}
                            checked={checked}
                            disabled={inTransit}/>
                    </div> : <Fragment/>}
                </div>
            </div>

        </Fragment>
    )
}

export default Event;